import { useFlag } from '@unleash/proxy-client-react';

const RETAKE_COUNTDOWN_FLAG = 'LTS-shutoff-PP-449-skill-challenge-retake-countdown';

export const useIsCountdownFlagActive = () => {
  return !useFlag(RETAKE_COUNTDOWN_FLAG);
};

export const getCooldownDuration = (attempts: number) => {
  const map = [30, 60, 120, 240, 480, 960]; // seconds
  const index = Math.min(attempts - 1, map.length - 1);
  return map[index] * 1000;
};
